const isDevelopment = import.meta.env.MODE === 'development';

const logger = {
  info: (message, ...optionalParams) => {
      if (isDevelopment) {
          console.info(message, ...optionalParams);
      }
  },
  error: (message, ...optionalParams) => {
      console.error(message, ...optionalParams);
  },
  warn: (message, ...optionalParams) => {
      if (isDevelopment) {
          console.warn(message, ...optionalParams);
      }
  },
  debug: (message, ...optionalParams) => {
      if (isDevelopment) {
          console.debug(message, ...optionalParams);
      }
  }
};

export default logger;